<template><svg width="30" height="30" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30">
  <path fill="currentColor" d="M10 2H20V27H10z" />
</svg>
</template>